import './constants';
/**
 * Uses similar algorithm to Moment to return a Date at the start of `unit`
 */
export const startOf = (dateInput, startOfUnit) => {
    const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
    switch (startOfUnit) {
        case 'y':
            return new Date(d.getFullYear(), 0, 1);
        case 'M':
            return new Date(d.getFullYear(), d.getMonth(), 1);
        case 'w':
            return new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay());
        case 'd':
            return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }
    let time = d.getTime();
    switch (startOfUnit) {
        case 'h':
            time -= (time + -d.getTimezoneOffset() * 60000 /* MS.m */) % 3600000 /* MS.h */;
            break;
        case 'm':
            time -= time % 60000 /* MS.m */;
            break;
        case 's':
            time -= time % 1000 /* MS.s */;
            break;
    }
    return new Date(time);
};
//# sourceMappingURL=startOf.js.map